import axios from 'axios'

export default {
  /**
   * Gets and sets booking profiles
   */
  async getBookingProfiles({ commit, dispatch, rootState }, payload) {
    commit(
      'app/setLoading',
      { type: 'getBookingProfiles', state: true },
      { root: true }
    )
    commit('app/setError', null, { root: true })
    try {
      const config = {
        headers: { Authorization: `Bearer ${rootState.authentication.jwt}` }
      }
      await axios
        .get(`${process.env.VUE_APP_URL}/adminapi/booking-profiles`, config)
        .then(response => {
          commit('setBookingProfiles', response.data)
          commit('app/setLoading', { type: '', state: false }, { root: true })
          commit('app/setError', null, { root: true })
        })
    } catch (error) {
      if (error.response.status === 401) {
        dispatch('authentication/logout', null, { root: true })
      }
      commit(
        'app/setSnackbar',
        {
          show: true,
          type: 'error',
          message:
            error.response && error.response.data
              ? error.response.data.Error
              : payload.this.$vuetify.lang.t('$vuetify.ERROR_GLOBAL')
        },
        { root: true }
      )
      commit(
        'app/setLoading',
        { type: 'getBookingProfiles', state: false },
        { root: true }
      )
      commit('app/setError', error, { root: true })
    }
  },
  getBookingProfile({ commit, dispatch, rootState }, payload) {
    return new Promise((resolve, reject) => {
      commit(
        'app/setLoading',
        { type: 'getBookingProfile', state: true },
        { root: true }
      )
      commit('app/setError', null, { root: true })
      try {
        const config = {
          headers: { Authorization: `Bearer ${rootState.authentication.jwt}` }
        }
        axios
          .get(
            `${process.env.VUE_APP_URL}/adminapi/booking-profiles/${payload.bookingProfileId}`,
            config
          )
          .then(response => {
            commit('app/setLoading', { type: '', state: false }, { root: true })
            commit('app/setError', null, { root: true })
            resolve(response.data)
          })
      } catch (error) {
        if (error.response.status === 401) {
          dispatch('authentication/logout', null, { root: true })
        }
        commit(
          'app/setSnackbar',
          {
            show: true,
            type: 'error',
            message:
              error.response && error.response.data
                ? error.response.data.Error
                : payload.this.$vuetify.lang.t('$vuetify.ERROR_GLOBAL')
          },
          { root: true }
        )
        commit(
          'app/setLoading',
          { type: 'getBookingProfile', state: false },
          { root: true }
        )
        commit('app/setError', error, { root: true })
        reject(error)
      }
    })
  },
  /**
   * Gets and sets bookings
   */
  async getBookings({ commit, dispatch, state, rootState }, payload) {
    commit(
      'app/setLoading',
      { type: 'getBookings', state: true },
      { root: true }
    )
    commit('app/setError', null, { root: true })
    try {
      const config = {
        headers: { Authorization: `Bearer ${rootState.authentication.jwt}` }
      }

      let url = `${process.env.VUE_APP_URL}/adminapi/booking-profiles/${payload.bookingProfileId}/bookings?page=${state.currentPageNumber}&page_size=${state.pageSize}`
      if (payload.createdAt) {
        url += `&created_at=${payload.createdAt}`
      }
      if (payload.startTime) {
        url += `&from=${payload.startTime}`
      }
      if (payload.endTime) {
        url += `&to=${payload.endTime}`
      }
      if (payload.licensePlate) {
        url += `&licensePlate=${payload.licensePlate}`
      }
      if (payload.client) {
        url += `&client=${payload.client}`
      }
      if (payload.comments) {
        url += `&comments=${payload.comments}`
      }
      if (payload.extraFilter) {
        url += `&extraFilter=${payload.extraFilter}`
      }

      await axios.get(url, config).then(response => {
        const nextAvailablePage = parseInt(response.headers['x-next-page'], 10)
        commit('setBookings', response.data)
        commit('setNextAvailablePage', nextAvailablePage)
        commit('app/setLoading', { type: '', state: false }, { root: true })
        commit('app/setError', null, { root: true })
      })
    } catch (error) {
      if (error.response.status === 401) {
        dispatch('authentication/logout', null, { root: true })
      }
      commit(
        'app/setSnackbar',
        {
          show: true,
          type: 'error',
          message:
            error.response && error.response.data
              ? error.response.data.Error
              : payload.this.$vuetify.lang.t('$vuetify.ERROR_GLOBAL')
        },
        { root: true }
      )
      commit(
        'app/setLoading',
        { type: 'getBookings', state: false },
        { root: true }
      )
      commit('app/setError', error, { root: true })
    }
  },

  async putBooking({ commit, dispatch, state, rootState }, payload) {
    return new Promise((resolve, reject) => {
      commit(
        'app/setLoading',
        { type: 'putBooking', state: true },
        { root: true }
      )
      commit('app/setError', null, { root: true })
      const selectedBookingProfile =
        state.selectedBookingProfile ||
        state.bookingProfiles.find(
          profile => profile.BookingProfileID === state.selectedBookingProfileId
        )
      if (selectedBookingProfile) {
        commit('setSelectedBookingValue', {
          key: 'PlaceID',
          value: selectedBookingProfile.PlaceID
        })
        commit('setSelectedBookingValue', {
          key: 'BookingProfileID',
          value: selectedBookingProfile.BookingProfileID
        })
      }
      const config = {
        headers: {
          Authorization: `Bearer ${rootState.authentication.jwt}`,
          Language: rootState.app.selectedLanguage.code
        }
      }

      axios
        .put(
          `${process.env.VUE_APP_URL}/adminapi/bookings`,
          state.selectedBooking,
          config
        )
        .then(response => {
          commit('setBookingInBookingsArray', response.data)
          commit('app/setLoading', { type: '', state: false }, { root: true })
          commit('app/setError', null, { root: true })
          resolve(true)
          commit(
            'app/setSnackbar',
            {
              show: true,
              type: 'success',
              message: payload.this.$vuetify.lang.t(
                '$vuetify.BOOKING.PUT_SUCCESSFUL'
              )
            },
            { root: true }
          )
        })
        .catch(error => {
          if (error.response.status === 401) {
            dispatch('authentication/logout', null, { root: true })
          }
          commit(
            'app/setSnackbar',
            {
              show: true,
              type: 'error',
              message:
                error.response && error.response.data
                  ? error.response.data.Error
                  : payload.this.$vuetify.lang.t('$vuetify.ERROR_GLOBAL')
            },
            { root: true }
          )
          commit(
            'app/setLoading',
            { type: 'putBooking', state: false },
            { root: true }
          )
          commit('app/setError', error, { root: true })
          reject(error)
        })
    })
  },
  async postBooking({ commit, dispatch, state, rootState }, payload) {
    return new Promise((resolve, reject) => {
      commit(
        'app/setLoading',
        { type: 'postBooking', state: true },
        { root: true }
      )
      commit('app/setError', null, { root: true })
      const selectedBookingProfile =
        state.selectedBookingProfile ||
        state.bookingProfiles.find(
          profile => profile.BookingProfileID === state.selectedBookingProfileId
        )
      if (selectedBookingProfile) {
        commit('setSelectedBookingValue', {
          key: 'PlaceID',
          value: selectedBookingProfile.PlaceID
        })
        commit('setSelectedBookingValue', {
          key: 'BookingProfileID',
          value: selectedBookingProfile.BookingProfileID
        })
      }
      const config = {
        headers: {
          Authorization: `Bearer ${rootState.authentication.jwt}`,
          Language: rootState.app.selectedLanguage.code
        }
      }
      axios
        .post(
          `${process.env.VUE_APP_URL}/adminapi/bookings`,
          state.selectedBooking,
          config
        )
        .then(response => {
          commit('addBooking', response.data)
          commit('app/setLoading', { type: '', state: false }, { root: true })
          commit('app/setError', null, { root: true })
          resolve(true)
          commit(
            'app/setSnackbar',
            {
              show: true,
              type: 'success',
              message: payload.this.$vuetify.lang.t(
                '$vuetify.BOOKING.POST_SUCCESSFUL'
              )
            },
            { root: true }
          )
        })
        .catch(error => {
          if (error.response.status === 401) {
            dispatch('authentication/logout', null, { root: true })
          }
          commit(
            'app/setSnackbar',
            {
              show: true,
              type: 'error',
              message:
                error.response && error.response.data
                  ? error.response.data.Error
                  : payload.this.$vuetify.lang.t('$vuetify.ERROR_GLOBAL')
            },
            { root: true }
          )
          commit(
            'app/setLoading',
            { type: 'postBooking', state: false },
            { root: true }
          )
          commit('app/setError', error, { root: true })
          reject(error)
        })
    })
  },

  async deleteBooking({ commit, dispatch, rootState }, payload) {
    commit(
      'app/setLoading',
      { type: 'deleteBooking', state: true },
      { root: true }
    )
    commit('app/setError', null, { root: true })
    try {
      const config = {
        headers: { Authorization: `Bearer ${rootState.authentication.jwt}` }
      }

      await axios
        .delete(
          `${process.env.VUE_APP_URL}/adminapi/bookings/${payload.bookingId}`,
          config
        )
        .then(() => {
          commit('removeBooking', payload.bookingId)
          commit('app/setLoading', { type: '', state: false }, { root: true })
          commit('app/setError', null, { root: true })
        })
    } catch (error) {
      if (error.response.status === 401) {
        dispatch('authentication/logout', null, { root: true })
      }
      commit(
        'app/setSnackbar',
        {
          show: true,
          type: 'error',
          message:
            error.response && error.response.data
              ? error.response.data.Error
              : payload.this.$vuetify.lang.t('$vuetify.ERROR_GLOBAL')
        },
        { root: true }
      )
      commit(
        'app/setLoading',
        { type: 'deleteBooking', state: false },
        { root: true }
      )
      commit('app/setError', error, { root: true })
    }
  },
  /**
   * Get parking booking status by vehicle number
   */
  getBookingParkingStatusByVehicleNumber(
    { commit, dispatch, rootState },
    payload
  ) {
    commit(
      'app/setLoading',
      { type: 'getBookingParkingStatusByVehicleNumber', state: true },
      { root: true }
    )
    commit('app/setError', null, { root: true })

    return new Promise((resolve, reject) => {
      const config = {
        headers: { Authorization: `Bearer ${rootState.authentication.jwt}` }
      }

      axios
        .get(
          `${process.env.VUE_APP_URL}/adminapi/bookings/parking-status/${payload.placeId}?vehicleNumber=${payload.vehicle}`,
          config
        )
        .then(response => {
          commit('app/setLoading', { type: '', state: false }, { root: true })
          commit('app/setError', null, { root: true })
          resolve({
            licensePlate: response.data.LicensePlate,
            isParking: response.data.IsParking,
            startTime: response.data.StartTime
          })
        })
        .catch(error => {
          if (error.response.status === 401) {
            dispatch('authentication/logout', null, { root: true })
          }
          commit(
            'app/setSnackbar',
            {
              show: true,
              type: 'error',
              message:
                error.response && error.response.data
                  ? error.response.data.Error
                  : payload.this.$vuetify.lang.t('$vuetify.ERROR_GLOBAL')
            },
            { root: true }
          )
          commit(
            'app/setLoading',
            { type: 'getBookingParkingStatusByVehicleNumber', state: false },
            { root: true }
          )
          commit('app/setError', error, { root: true })
          reject(error)
        })
    })
  },
  getBookablePlaceBookingsHeatmap({ commit, dispatch, rootState }, payload) {
    commit(
      'app/setLoading',
      { type: 'getBookablePlaceBookingsHeatmap', state: true },
      { root: true }
    )
    commit('app/setError', null, { root: true })

    return new Promise((resolve, reject) => {
      const config = {
        headers: { Authorization: `Bearer ${rootState.authentication.jwt}` }
      }

      axios
        .get(
          `${process.env.VUE_APP_URL}/adminapi/booking-profiles/${payload.bookingProfileId}/heatmap?from=${payload.startTime}`,
          config
        )
        .then(response => {
          commit('app/setLoading', { type: '', state: false }, { root: true })
          commit('app/setError', null, { root: true })
          resolve(response.data)
        })
        .catch(error => {
          if (error.response.status === 401) {
            dispatch('authentication/logout', null, { root: true })
          }
          commit(
            'app/setSnackbar',
            {
              show: true,
              type: 'error',
              message:
                error.response && error.response.data
                  ? error.response.data.Error
                  : payload.this.$vuetify.lang.t('$vuetify.ERROR_GLOBAL')
            },
            { root: true }
          )
          commit(
            'app/setLoading',
            { type: 'getBookablePlaceBookingsHeatmap', state: false },
            { root: true }
          )
          commit('app/setError', error, { root: true })
          reject(error)
        })
    })
  },
  async endBooking({ commit, dispatch, state, rootState }, payload) {
    return new Promise((resolve, reject) => {
      commit(
        'app/setLoading',
        { type: 'endBooking', state: true },
        { root: true }
      )
      commit('app/setError', null, { root: true })
      const selectedBookingProfile =
        state.selectedBookingProfile ||
        state.bookingProfiles.find(
          profile => profile.BookingProfileID === state.selectedBookingProfileId
        )
      if (selectedBookingProfile) {
        commit('setSelectedBookingValue', {
          key: 'PlaceID',
          value: selectedBookingProfile.PlaceID
        })
      }
      const config = {
        headers: {
          Authorization: `Bearer ${rootState.authentication.jwt}`,
          Language: rootState.app.selectedLanguage.code
        }
      }
      axios
        .post(
          `${process.env.VUE_APP_URL}/adminapi/bookings/${payload.bookingId}/end`,
          null,
          config
        )
        .then(response => {
          const { ID, EndTime } = response.data
          commit('updateBookingEndTime', { ID, EndTime })
          commit('app/setLoading', { type: '', state: false }, { root: true })
          commit('app/setError', null, { root: true })
          resolve(true)
        })
        .catch(error => {
          if (error.response.status === 401) {
            dispatch('authentication/logout', null, { root: true })
          }
          commit(
            'app/setSnackbar',
            {
              show: true,
              type: 'error',
              message:
                error.response && error.response.data
                  ? error.response.data.Error
                  : payload.this.$vuetify.lang.t('$vuetify.ERROR_GLOBAL')
            },
            { root: true }
          )
          commit(
            'app/setLoading',
            { type: 'endBooking', state: false },
            { root: true }
          )
          commit('app/setError', error, { root: true })
          reject(error)
        })
    })
  },
  getBooking({ commit, dispatch, rootState }, payload) {
    return new Promise((resolve, reject) => {
      commit(
        'app/setLoading',
        { type: 'getBooking', state: true },
        { root: true }
      )
      commit('app/setError', null, { root: true })

      const config = {
        headers: { Authorization: `Bearer ${rootState.authentication.jwt}` }
      }
      axios
        .get(
          `${process.env.VUE_APP_URL}/adminapi/booking/${payload.bookingId}`,
          config
        )
        .then(response => {
          commit('app/setLoading', { type: '', state: false }, { root: true })
          commit('app/setError', null, { root: true })
          resolve(response.data)
        })
        .catch(error => {
          if (error.response.status === 401) {
            dispatch('authentication/logout', null, { root: true })
          }
          commit(
            'app/setSnackbar',
            {
              show: true,
              type: 'error',
              message:
                error.response && error.response.data
                  ? error.response.data.Error
                  : payload.this.$vuetify.lang.t('$vuetify.ERROR_GLOBAL')
            },
            { root: true }
          )
          commit(
            'app/setLoading',
            { type: 'getBooking', state: false },
            { root: true }
          )
          commit('app/setError', error, { root: true })
          reject(error)
        })
    })
  },
  /**
   * Get price for booking period
   */
  getPriceForBookingInPlace({ commit, dispatch, rootState }, payload) {
    commit(
      'app/setLoading',
      { type: 'getPriceForBookingInPlace', state: true },
      { root: true }
    )
    commit('app/setError', null, { root: true })

    return new Promise((resolve, reject) => {
      const config = {
        headers: {
          Authorization: `Bearer ${rootState.authentication.jwt}`,
          Language: rootState.app.selectedLanguage.code
        }
      }
      axios
        .get(
          `${process.env.VUE_APP_URL}/adminapi/booking-profiles/${payload.bookingProfileId}/price-for-booking-period?startTime=${payload.start}&endTime=${payload.end}`,
          config
        )
        .then(response => {
          commit('app/setLoading', { type: '', state: false }, { root: true })
          commit('app/setError', null, { root: true })
          resolve(response.data)
        })
        .catch(error => {
          if (error.response.status === 401) {
            dispatch('authentication/logout', null, { root: true })
          }
          commit(
            'app/setSnackbar',
            {
              show: true,
              type: 'error',
              message:
                error.response && error.response.data
                  ? error.response.data.Error
                  : payload.this.$vuetify.lang.t('$vuetify.ERROR_GLOBAL')
            },
            { root: true }
          )
          commit(
            'app/setLoading',
            { type: 'getPriceForBookingInPlace', state: false },
            { root: true }
          )
          commit('app/setError', error, { root: true })
          reject(error)
        })
    })
  },
  getBookingReportXLSXFile({ commit, rootState }, payload) {
    return new Promise((resolve, reject) => {
      commit(
        'app/setLoading',
        { type: 'getBookingReportXLSXFile', state: true },
        { root: true }
      )
      commit('app/setError', null, { root: true })
      try {
        const config = {
          responseType: 'blob',
          headers: {
            Authorization: `Bearer ${rootState.authentication.jwt}`,
            Accept:
              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            Language: rootState.app.selectedLanguage.code
          }
        }
        const params = []
        if (payload.createdAt) params.push(`created_at=${payload.createdAt}`)
        if (payload.startTime) params.push(`from=${payload.startTime}`)
        if (payload.endTime) params.push(`to=${payload.endTime}`)
        if (payload.licensePlate) params.push(`licensePlate=${payload.licensePlate}`)
        if (payload.client) params.push(`client=${payload.client}`)
        if (payload.comments) params.push(`comments=${payload.comments}`)
        if (payload.extraFilter) params.push(`extraFilter=${payload.extraFilter}`)
        const query = params.length ? `?${params.join('&')}` : ''
        const reportUrl = `${process.env.VUE_APP_URL}/adminapi/booking-profiles/${payload.bookingProfileId}/report${query}`
        axios
          .get(reportUrl, config)
          .then(response => {
            resolve(response)
            commit('app/setLoading', { type: '', state: false }, { root: true })
            commit('app/setError', null, { root: true })
          })
      } catch (error) {
        reject(error)
        commit(
          'app/setLoading',
          { type: 'getBookingReportXLSXFile', state: false },
          { root: true }
        )
        commit('app/setError', error, { root: true })
      }
    })
  }
}
